import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52dfe4c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold mb-4" }, "Daftar transaksi pengisian BBM", -1))
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold text-neutral-700 mb-3" }, "Status Liter Pengisian", -1))
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold text-neutral-700 mb-3" }, "Status Transaksi", -1))
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold text-neutral-700 mb-3" }, "Pom Mitra", -1))
const _hoisted_10 = ["for"]

import Card from 'primevue/card'
import FilterSidebar from '@/views/components/sidebar/FilterSidebar.vue'
import Checkbox from 'primevue/checkbox'
import Divider from 'primevue/divider'
import { useRouter } from 'vue-router'
import { IFuelingTransaction } from '@/utils/interfaces/iFuelMonitoring'
import { useFuelMonitoring } from '@/composables/pages/externals/fuel-monitoring/useFuelMonitoring'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import FilterBar from './components/FilterBar.vue'
import TransactionTables from './components/TransactionTables.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter()

const {
  filterDate,
  searchQuery,

  // Trayek (Level 1)
  trayekList,
  isLoadingTrayeks,
  expandedTrayekIds,
  trayekPaginate,

  // PP Transactions per Trayek (Level 2)
  trayekTransactions,
  trayekTransactionLoading,
  trayekTransactionPaginate,

  // Expanded PP rows (Level 3)
  expandedPpRows,

  // Trayek handlers
  onExpandTrayek,
  onChangeTrayekPage,
  onChangePpPage,
  onExpandPpRow,
  fetchTrayeks,
  fetchTransactionNonPpData,

  // Non-PP
  transactionNonPpList,
  isLoadingTransactionNonPp,
  expandedTransactionNonPpRows,
  transactionNonPpPaginate,
  transactionNonPpRowData,
  onChangeTransactionNonPpPage,
  onExpandedTransactionNonPpRowsChange,

  // Filter
  isFilterDrawerOpen,
  selectedFuelUsageStatuses,
  selectedApprovalStatuses,
  selectedPartnerIds,
  fuelUsageStatusOptions,
  approvalStatusOptions,
  partnerOptions,
  applyFilter,
  activeFilters,
  removeFilter,

  // Utils
  getStatusLabel
} = useFuelMonitoring()

const openDetail = (item: IFuelingTransaction) => {
  const encryptedId = encryptDecriptMethods.encrypt(item.Id)
  router.push({ name: 'fuel-monitoring-detail', params: { id: encryptedId } })
}

const handleSearch = () => {
  // Reset expanded states and re-fetch with search query
  expandedTrayekIds.value = []
  trayekTransactions.value = {}
  fetchTrayeks()
  fetchTransactionNonPpData()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
      content: _withCtx(() => [
        _hoisted_1,
        _createVNode(FilterBar, {
          filterDate: _unref(filterDate),
          "onUpdate:filterDate": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filterDate) ? (filterDate).value = $event : null)),
          searchQuery: _unref(searchQuery),
          "onUpdate:searchQuery": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
          activeFilters: _unref(activeFilters),
          onOpenFilter: _cache[2] || (_cache[2] = ($event: any) => (isFilterDrawerOpen.value = true)),
          onSearch: handleSearch,
          onRemoveFilter: _unref(removeFilter)
        }, null, 8, ["filterDate", "searchQuery", "activeFilters", "onRemoveFilter"]),
        _createVNode(TransactionTables, {
          trayekList: _unref(trayekList),
          isLoadingTrayeks: _unref(isLoadingTrayeks),
          expandedTrayekIds: _unref(expandedTrayekIds),
          trayekPaginate: _unref(trayekPaginate),
          trayekTransactions: _unref(trayekTransactions),
          trayekTransactionLoading: _unref(trayekTransactionLoading),
          trayekTransactionPaginate: _unref(trayekTransactionPaginate),
          expandedPpRows: _unref(expandedPpRows),
          transactionNonPpRowData: _unref(transactionNonPpRowData),
          transactionNonPpList: _unref(transactionNonPpList),
          isLoadingTransactionNonPp: _unref(isLoadingTransactionNonPp),
          transactionNonPpPaginate: _unref(transactionNonPpPaginate),
          expandedTransactionNonPpRows: _unref(expandedTransactionNonPpRows),
          getStatusLabel: _unref(getStatusLabel),
          onExpandTrayek: _unref(onExpandTrayek),
          onChangeTrayekPage: _unref(onChangeTrayekPage),
          onChangePpPage: _unref(onChangePpPage),
          onExpandPpRow: _unref(onExpandPpRow),
          onExpandedTransactionNonPpRowsChange: _unref(onExpandedTransactionNonPpRowsChange),
          onOnChangeTransactionNonPpPage: _unref(onChangeTransactionNonPpPage),
          onOpenDetail: openDetail
        }, null, 8, ["trayekList", "isLoadingTrayeks", "expandedTrayekIds", "trayekPaginate", "trayekTransactions", "trayekTransactionLoading", "trayekTransactionPaginate", "expandedPpRows", "transactionNonPpRowData", "transactionNonPpList", "isLoadingTransactionNonPp", "transactionNonPpPaginate", "expandedTransactionNonPpRows", "getStatusLabel", "onExpandTrayek", "onChangeTrayekPage", "onChangePpPage", "onExpandPpRow", "onExpandedTransactionNonPpRowsChange", "onOnChangeTransactionNonPpPage"])
      ]),
      _: 1
    }),
    _createVNode(FilterSidebar, {
      modelValue: _unref(isFilterDrawerOpen),
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(isFilterDrawerOpen) ? (isFilterDrawerOpen).value = $event : null)),
      onApply: _unref(applyFilter)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fuelUsageStatusOptions), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.Name,
              class: "flex items-center mb-2"
            }, [
              _createVNode(_unref(Checkbox), {
                modelValue: _unref(selectedFuelUsageStatuses),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(selectedFuelUsageStatuses) ? (selectedFuelUsageStatuses).value = $event : null)),
                inputId: 'usage_'+item.Name,
                name: "usageStatus",
                value: item.Name
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: 'usage_'+item.Name,
                class: "ml-2 text-sm text-neutral-600 cursor-pointer"
              }, _toDisplayString(item.Description), 9, _hoisted_4)
            ]))
          }), 128))
        ]),
        _createVNode(_unref(Divider), { class: "my-4" }),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(approvalStatusOptions), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.Name,
              class: "flex items-center mb-2"
            }, [
              _createVNode(_unref(Checkbox), {
                modelValue: _unref(selectedApprovalStatuses),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(selectedApprovalStatuses) ? (selectedApprovalStatuses).value = $event : null)),
                inputId: 'appr_'+item.Name,
                name: "apprStatus",
                value: item.Name
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: 'appr_'+item.Name,
                class: "ml-2 text-sm text-neutral-600 cursor-pointer"
              }, _toDisplayString(item.Description), 9, _hoisted_7)
            ]))
          }), 128))
        ]),
        _createVNode(_unref(Divider), { class: "my-4" }),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partnerOptions), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.Id,
              class: "flex items-center mb-2"
            }, [
              _createVNode(_unref(Checkbox), {
                modelValue: _unref(selectedPartnerIds),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(selectedPartnerIds) ? (selectedPartnerIds).value = $event : null)),
                inputId: 'partner_'+item.Id,
                name: "partner",
                value: item.Id
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: 'partner_'+item.Id,
                class: "ml-2 text-sm text-neutral-600 cursor-pointer"
              }, _toDisplayString(item.Name), 9, _hoisted_10)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onApply"])
  ], 64))
}
}

})